import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Customform from "../../../components/commonComponent/Customform";
import AWS from "../../../utils/awsConfig.js";
import { LOADING, MODE } from "../../../constants/SiteConstants";

const API_URL = process.env.REACT_APP_API_URL;

const fields = [
  { label: "Title", name: "title", placeholder: "Enter Title", required: true },
  { label: "Date", name: "date", placeholder: "Select Date", required: true, type: "date" },
  { label: "Slug", name: "slug", placeholder: "Enter Slug" },
  {
    label: "Brief Description",
    name: "briefDescription",
    placeholder: "Enter brief description",
    required: true,
  },
  {
    label: "Description",
    name: "description",
    placeholder: "Enter description",
    type: "rich-text",
    required: true,
  },
  {
    label: "Read Time",
    name: "readtime",
    placeholder: "e.g. 3 ",
    required: true,
  },
  {
    label: "Meta Title",
    name: "metaTitle",
    placeholder: "Enter Meta Title",
    required: true,
  },
  {
    label: "Meta Description",
    name: "metaDescription",
    placeholder: "Enter Meta Description",
    required: true,
  },
  {
    label: "Keywords",
    name: "keywords",
    placeholder: "Enter Comma Separated keywords",
    required: true,
  },
  {
    label: "Is Featured",
    name: "isFeatured",
    type: "select",
    options: [
      { label: "True", value: true },
      { label: "False", value: false },
    ],
  },
  {
    label: "Tags",
    name: "tags",
    placeholder: "Add tags",
    required: true,
  },
  {
    label: "Images",
    name: "images",
    placeholder: "Choose Images",
    type: "file",
  },
  {
    label: "Product category",
    name: "productcategory",
    placeholder: "Select category",
    isMultifield: true,
  },
  {
    label: "Blog category",
    name: "blogcategory",
    placeholder: "Select category",
    isMultifield: true,
  },
];

const EditBlob = () => {
  const { id } = useParams();
  const [initialData, setInitialData] = useState(null);
  const [imageFiles, setImageFiles] = useState([]);
  const [imagePreview, setImagePreview] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const loadBlogData = async () => {
        try {
          const response = await axios.get(`${API_URL}/blogs/getBlogById/${id}`);
          const blogData = response.data.data;
            if (blogData.readtime) {
              blogData.readtime = blogData.readtime.toString().replace(/\D/g, ""); // e.g. "5 min read" → "5"
            }
            setInitialData(blogData);
          setInitialData(blogData);
          setImagePreview(blogData.images || []);
        } catch (error) {
          console.error("Error fetching blog data:", error);
        }
      };
      loadBlogData();
    }
  }, [id]);

const handleImageUpload = async (file) => {
  if (!file) {
    toast.error("No file selected!");
    return null;
  }

  const formData = new FormData();
  formData.append("image", file);

  try {
    const response = await fetch(`${API_URL}/image/upload`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Upload failed");
    }

    return data.imageUrl;
  } catch (error) {
    console.error("Upload Error:", error);
    toast.error("Error uploading image: " + error.message);
    return null;
  }
};



  const handleSubmit = async (formData) => {
    try {
      const validImageURLs = imagePreview.filter((url) => !url.startsWith("blob:"));
      let uploadedImages = [...validImageURLs];

      if (imageFiles.length > 0) {
        const uploadPromises = imageFiles.map((file) => handleImageUpload(file));
        const uploadedImageURLs = await Promise.all(uploadPromises);
        uploadedImages = [...uploadedImages, ...uploadedImageURLs];
      }

      const updatedFormData = {
          ...formData,
        readtime: `${formData.readtime} min read`,
        images: uploadedImages,
        productcategory: formData.productcategory?.map((item) => item.value) || [],
        blogcategory: formData.blogcategory?.map((item) => item.value) || [],
      };


      toast.info("Updating data...", { autoClose: 1000 });

      const response = await axios.put(`${API_URL}/blogs/updateBlogById/${id}`, updatedFormData);

      if (response.status === 200) {
        toast.success("Data updated successfully", { autoClose: 1000 });
        navigate("/blogManagement");
      } else {
        toast.warn("Data update completed with warnings", { autoClose: 1000 });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred while updating data";
      toast.error(`Error updating data: ${errorMessage}`, { autoClose: 2000 });
      console.error("Update Error:", error);
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImagePreview(files.map((file) => URL.createObjectURL(file)));
    setImageFiles(files);
  };

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Update Blog
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/blogManagement")}
        >
          &times;
        </button>
      </div>
      {initialData ? (
        <Customform
          mode={MODE.UPDATE}
          onSubmit={handleSubmit}
          fields={fields}
          initialData={initialData}
          imagePreviews={imagePreview}
          handleCustomerImageChange={handleImageChange}
        />
      ) : (
        <p>{LOADING}</p>
      )}
    </div>
  );
};

export default EditBlob;
